import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1 0C0.447715 0 0 0.447715 0 1V23C0 23.5523 0.447715 24 1 24H17.7578C17.3205 23.3467 17.0497 22.5725 17.0062 21.7381C16.2899 22.2192 15.4277 22.5 14.5 22.5C12.0147 22.5 10 20.4853 10 18C10 15.5147 12.0147 13.5 14.5 13.5C15.4277 13.5 16.2899 13.7808 17.0062 14.2619C17.1029 12.4065 18.3235 10.8486 20 10.2561V7C20 6.73478 19.8946 6.48043 19.7071 6.29289L13.7071 0.292893C13.5196 0.105357 13.2652 0 13 0H1ZM13 2V7H18L13 2ZM3 12H12V10H3V12ZM8 17H3V15H8V17ZM21.5 24C22.8807 24 24 22.8807 24 21.5C24 20.1193 22.8807 19 21.5 19C20.8903 19 20.3316 19.2182 19.8977 19.5808L16.9967 18.1303C16.9989 18.0871 17 18.0437 17 18C17 17.9563 16.9989 17.9128 16.9967 17.8697L19.8978 16.4192C20.3316 16.7818 20.8903 17 21.5 17C22.8807 17 24 15.8807 24 14.5C24 13.1193 22.8807 12 21.5 12C20.1193 12 19 13.1193 19 14.5C19 14.5437 19.0011 14.5871 19.0033 14.6303L16.1023 16.0808C15.6684 15.7182 15.1097 15.5 14.5 15.5C13.1193 15.5 12 16.6193 12 18C12 19.3807 13.1193 20.5 14.5 20.5C15.1097 20.5 15.6683 20.2817 16.1022 19.9191L19.0033 21.3697C19.0011 21.4128 19 21.4563 19 21.5C19 22.8807 20.1193 24 21.5 24Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }